Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalsQuery = void 0;
exports.globalsQuery = {
  componentName: 'globals',
  query: "\n  {\n    globals: allContentfulGlobals {\n      edges {\n        node {\n          id\n          node_locale\n        }\n      }\n    }\n  }\n",
  type: 'global'
};